<template>
  <div class="query">
    <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
    <MyHeader msg="二维码追溯结果" />
    <MyContent :dataRes="dataRes" />
    <MyFooter :dataRes="dataRes" />

  </div>
</template>

<script>
import { findByCode, checkByCode } from "@/api/scan";
// @ is an alias to /src
import MyContent from '@/components/MyContent.vue'
import MyHeader from '@/components/MyHeader.vue'
import MyFooter from '@/components/MyFooter.vue'

export default {
  name: 'QueryView',
  components: {
    MyContent,
    MyHeader,
    MyFooter
  },
  data() {
    return {
      // coperight: '广西田园生化股份有限公司',
      coperight: '',
      dataRes: {
        // registName:undefined,
        // registNo:null,
        // registCompany:null,
        // registName:null,
        // registName:null,
        // registName:null,
        // registName:null,
        // registName:null,
        // registName:null,
        // registName:null,
      },
      code: ""
    }
  },

  created() {
    this.onSubmit();
  },

  methods: {
    onSubmit() {
      this.code = this.$route.query.c;
      console.log("路径的code", this.code);
      // 先走 checkByCode 分流：特殊码跳转 TurnView 展示，否则走 findByCode 正常追溯
      checkByCode(this.code).then(response => {
        if (response.code == 200 && response.data.result) {
          this.$router.push('/q/turn.do?c=' + this.code);
          return;
        }
        this.query();
      });
    },
    query() {
      findByCode(this.code).then(response => {
        if (response.code == 200) {
          this.dataRes = response.data;
        } else {
          // this.$toast('编码不存在……');
          // 危险通知
          this.$notify('编码不存在……');
        }

        this.coperight = this.dataRes.produceCompany;//动态更改网页版权不合适，管局会查，有风险
      }
      );
    },
  }
}
</script>
